module.exports = __webpack_public_path__ + "static/img/banner2_phone.69da5cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/banner2_phone.png
// module id = BoqB
// module chunks = 1